import { supabase } from "@/integrations/supabase/client";
import { TokenServiceError } from "./types";

export async function logTokenError(type: string, error: any): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    await supabase
      .from('token_error_logs')
      .insert({
        user_id: user.id,
        error_type: type,
        error_message: error.message,
        stack_trace: error.stack,
        metadata: { originalError: error }
      });
  } catch (logError) {
    console.error('Error logging token error:', logError);
  }
}